import KTCheckbox, {
  KTCheckboxType,
} from 'general/components/OtherKeenComponents/KTFormControls/KTCheckbox';
import AppColors from 'general/constants/AppColors';
import UIHelper from 'general/helpers/UIHelper';
import useOnClickOutside from 'hooks/useOnClickOutside';
import PropTypes from 'prop-types';
import { useEffect, useRef, useState } from 'react';

DropdownMultiChoiceView.propTypes = {
  items: PropTypes.array,
  initialSelectedValues: PropTypes.array,
  onChange: PropTypes.func,
  hasCheckAll: PropTypes.bool,
  placeholder: PropTypes.string,
  readyToValidData: PropTypes.bool,
  disabled: PropTypes.bool,
};

function DropdownMultiChoiceView({ items = [], initialSelectedValues = [], onChange, hasCheckAll = true, placeholder = '', readyToValidData = false, disabled = false }) {
  // MARK: ---- PROPERTIES ----
  const ref = useRef();
  const [zIndex, setZIndex] = useState('');
  const [show, setShow] = useState(false);

  useEffect(() => {
    setZIndex(show ? '9999' : '');
  }, [show]);

  useOnClickOutside(ref, () => {
    if (show) {
      setShow(false);
      if (onChange) {
        onChange(checkedItems);
      }
    }
  });
  const [checkedItems, setCheckedItems] = useState([]);

  useEffect(() => {
    setCheckedItems(initialSelectedValues || []);
  }, [initialSelectedValues]);

  // MARK: ---- METHODS ----
  const toggleCheckItem = (item) => {
    const value = item?.value;
    let newCheckedItems;
    if (checkedItems.includes(value)) {
      newCheckedItems = checkedItems.filter((i) => i !== value);
    } else {
      newCheckedItems = [...checkedItems, value];
    }
    setCheckedItems(newCheckedItems);
  };

  const handleCheckAll = () => {
    let newCheckedItems;
    if (checkedItems.length === items.length) {
      newCheckedItems = [];
    } else {
      newCheckedItems = items.map((item) => item?.value);
    }
    setCheckedItems(newCheckedItems);
  };

  return (
    <div ref={ref} className="position-relative" style={{ zIndex: zIndex }}>
      <button
        className={`btn btn-white border-secondary dropdown-toggle w-100 d-flex align-items-center justify-content-between
          ${readyToValidData && !checkedItems?.length ? 'border-invalid' : ''}
          ${disabled ? 'disabled' : ''}`}
        type="button"
        onClick={() => {
          setShow(!show);
        }}
      >
        <span className="w-100 text-ellipsis-1-lines text-left">
          {items
            ?.filter((item) => item?.value && checkedItems?.includes(item.value))
            .map((item) => item?.name)
            .join(', ') || placeholder || 'Chọn bộ lọc'}
        </span>
      </button>
      {show && (
        <div
          className="position-absolute bg-white shadow-sm filter-dropdown-content w-100"
          style={{
            borderRadius: '5px',
            zIndex: '9999',
          }}
        >
          <div className="my-2">
            {hasCheckAll && (
              <div
                className="dropdown-item d-flex align-items-center justify-content-between cursor-pointer px-4"
                onClick={() => {
                  handleCheckAll();
                }}
              >
                <span style={UIHelper.buildFontStyle('400', '14px', AppColors.gray[800])}>
                  Tất cả
                </span>
                <span
                  onClick={(e) => {
                    e.stopPropagation();
                  }}
                >
                  <KTCheckbox
                    name={`checkbox-all`}
                    additionalClassName="checkbox-success"
                    type={KTCheckboxType.default}
                    onChange={() => {
                      handleCheckAll();
                    }}
                    checked={checkedItems.length === items.length}
                  />
                </span>
              </div>
            )}
            {items.map((item, index) => (
              <div
                key={item?.value ?? index}
                className="dropdown-item d-flex align-items-center justify-content-between cursor-pointer px-4"
                onClick={() => {
                  toggleCheckItem(item);
                }}
              >
                <span style={UIHelper.buildFontStyle('400', '14px', AppColors.gray[800])}>
                  {item?.name}
                </span>
                <span
                  onClick={(e) => {
                    e.stopPropagation();
                  }}
                >
                  <KTCheckbox
                    name={`checkbox-${index}`}
                    additionalClassName="checkbox-success"
                    type={KTCheckboxType.default}
                    onChange={() => {
                      toggleCheckItem(item);
                    }}
                    checked={checkedItems.includes(item?.value)}
                  />
                </span>
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
}

export default DropdownMultiChoiceView;